import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';


const SearchBar = ({ searchQuery, onSearch, trendingTopics }) => {
  const [localQuery, setLocalQuery] = useState(searchQuery);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const searchRef = useRef(null);

  const mockSuggestions = [
    'How to create a form',
    'How to integrate payment processors',
    'How to review form submissions',
    'How to export submission data',
    'How to customize form design',
    'How to add conditional logic',
    'How to embed forms on website',
    'How to manage team members'
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef?.current && !searchRef?.current?.contains(event?.target)) {
        setShowSuggestions(false);
      }
    };

    document?.addEventListener('mousedown', handleClickOutside);
    return () => document?.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    const value = e?.target?.value;
    setLocalQuery(value);

    if (value?.trim()?.length > 2) {
      const filtered = mockSuggestions?.filter(s =>
        s?.toLowerCase()?.includes(value?.toLowerCase())
      );
      setSuggestions(filtered);
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  };

  const handleSearch = (query) => {
    onSearch(query || localQuery);
    setShowSuggestions(false);
  };

  const handleKeyPress = (e) => {
    if (e?.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setLocalQuery(suggestion);
    handleSearch(suggestion);
  };

  return (
    <div className="max-w-3xl mx-auto" ref={searchRef}>
      <div className="relative">
        <div className="relative">
          <Icon
            name="Search"
            size={20}
            className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none"
          />
          <input
            type="search"
            placeholder="Search for articles, guides, or topics..."
            value={localQuery}
            onChange={handleInputChange}
            onKeyPress={handleKeyPress}
            onFocus={() => localQuery?.length > 2 && setShowSuggestions(true)}
            className="w-full h-14 pl-12 pr-24 rounded-lg border-2 border-border bg-card text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-smooth text-base"
          />
          <button
            onClick={() => handleSearch()}
            className="absolute right-2 top-1/2 -translate-y-1/2 h-10 px-6 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-smooth font-medium"
          >
            Search
          </button>
        </div>

        {/* Suggestions Dropdown */}
        {showSuggestions && suggestions?.length > 0 && (
          <div className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-elevation-lg max-h-80 overflow-y-auto z-50">
            {suggestions?.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => handleSuggestionClick(suggestion)}
                className="w-full px-4 py-3 text-left hover:bg-muted transition-smooth flex items-center gap-3 border-b border-border last:border-0"
              >
                <Icon name="Search" size={16} className="text-muted-foreground" />
                <span className="text-sm text-foreground">{suggestion}</span>
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Trending Topics */}
      {trendingTopics?.length > 0 && (
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-sm text-muted-foreground">Trending:</span>
          {trendingTopics?.map((topic, index) => (
            <button
              key={index}
              onClick={() => handleSearch(topic)}
              className="px-3 py-1 bg-muted hover:bg-muted/80 text-foreground rounded-full text-sm transition-smooth"
            >
              {topic}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchBar;